module.exports = __webpack_public_path__ + "img/teamitelogo.4f4daed6.webp";